import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

export default class Panel extends PureComponent {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    className: PropTypes.string
  };

  static defaultProps = {
    className: ""
  };

  constructor(props) {
    super(props);
    this.isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
    this.panel = null;
    this.summary = null;
    this.subnav = null;
    this.tools = null;
    this.filters = null;
    this.detailsFilters = null;
    this.sortedList = null;
    this.rowHeader = null;
    this.originalTop = null;
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll, true);
    this.panel = this.panelRef.current;
    this.panelContainer = document.getElementById("panelContainer");
  }

  componentDidUpdate() {
    this.originalTop = this.panel.parentNode.getBoundingClientRect().top;
    this.summary = this.panel.querySelector(".panel-summary") || null;
    this.subnav = this.panel.querySelector(".panel-subnav") || null;
    this.tools = this.panel.querySelector(".panel-tools") || null;
    this.filters = this.panel.querySelector(".sorted-list__filters") || null;
    this.detailsFilters = this.panel.querySelector(".filters") || null;
    this.sortedList = this.panel.querySelector(".sorted-list") || null;
    this.rowHeader = this.panel.querySelector(".sorted-list__row-header") || null;
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll, true);
  }

  handleScroll = () => {
    const { top } = this.panel.getBoundingClientRect();

    if (top > this.originalTop) {
      this.panelContainer.classList.add("--overscroll");
    } else {
      this.panelContainer.classList.remove("--overscroll");
    }

    if (this.summary && (this.panel.classList.contains("details-page") || this.panel.classList.contains("order-page"))) {
      if (this.subnav && this.tools && top <= this.originalTop - parseFloat(getComputedStyle(this.summary).height)) {
        this.subnav.classList.add("--fixed");
        this.tools.classList.add("--fixed");
        this.panel.classList.add("--has-fixed-subnav");
        this.panel.classList.add("--has-fixed-tools");
      } else {
        this.subnav.classList.remove("--fixed");
        this.tools.classList.remove("--fixed");
        this.panel.classList.remove("--has-fixed-subnav");
        this.panel.classList.remove("--has-fixed-tools");
      }
      if (this.summary && this.rowHeader && this.panel.classList.contains("details-page")) {
        if (this.detailsFilters) {
          this.panel.classList.add("--has-details-filters");
          if (
            this.rowHeader &&
            top <= this.originalTop - parseFloat(getComputedStyle(this.summary).height) - parseFloat(getComputedStyle(this.detailsFilters).height)
          ) {
            this.rowHeader.classList.add("--fixed");
            this.panel.classList.add("--has-fixed-row-header");
          } else {
            this.rowHeader.classList.remove("--fixed");
            this.panel.classList.remove("--has-fixed-row-header");
          }
        } else if (this.rowHeader && top <= this.originalTop - parseFloat(getComputedStyle(this.summary).height)) {
          this.rowHeader.classList.add("--fixed");
          this.panel.classList.add("--has-fixed-row-header");
        } else {
          this.rowHeader.classList.remove("--fixed");
          this.panel.classList.remove("--has-fixed-row-header");
        }
      } else if (this.rowHeader && this.panel.classList.contains("order-page")) {
        if (top <= this.originalTop - parseFloat(getComputedStyle(this.summary).height)) {
          this.rowHeader.classList.add("--fixed");
          this.panel.classList.add("--has-fixed-row-header");
        } else {
          this.rowHeader.classList.remove("--fixed");
          this.panel.classList.remove("--has-fixed-row-header");
        }
      }
    }

    if (this.filters && this.rowHeader && this.panel.classList.contains("list-page")) {
      if (top <= this.originalTop - parseFloat(getComputedStyle(this.filters).height)) {
        this.rowHeader.classList.add("--fixed");
        this.panel.classList.add("--has-fixed-row-header");
      } else {
        this.rowHeader.classList.remove("--fixed");
        this.panel.classList.remove("--has-fixed-row-header");
      }
    }

    if (this.rowHeader && this.panel.classList.contains("purchase-order-list-page")) {
      if (top <= this.originalTop - (this.isSafari ? parseFloat(getComputedStyle(this.rowHeader).height) : 1)) {
        this.rowHeader.classList.add("--fixed");
        this.panel.classList.add("--has-fixed-row-header");
      } else {
        this.rowHeader.classList.remove("--fixed");
        this.panel.classList.remove("--has-fixed-row-header");
      }
    }

    if (this.sortedList && this.rowHeader && getComputedStyle(this.rowHeader).position === "fixed") {
      this.rowHeader.style.left = `${this.sortedList.getBoundingClientRect().left}px`;
    }
  };

  panelRef = React.createRef();

  render() {
    return (
      <section role="main" className={classNames("panel", this.props.className)} ref={this.panelRef}>
        {React.Children.map(this.props.children, child => child)}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/Panel/Panel.js